import Swal from 'sweetalert2';
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Aspirantes = {
    obtenerAspirantes: async id => {
        let url = url_json + "/aspirante/" + id
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarAspirantes: async (data, id) => {
        return Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea modificar los datos de aspirantes?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let url = url_json + "/aspirante/" + id;

                let body = {
                    inicio_cine_animacion: data.inicio_cine_animacion,
                    siguiente_inicio_cine_animacion: data.siguiente_inicio_cine_animacion,
                    siguiente_inicio_marketing: data.siguiente_inicio_marketing ?? '',
                    dia_limite_colegiatura: Number(data.dia_limite_colegiatura),
                    calendario_vigente: data.calendario_vigente,
                    dias_pago_contado: Number(data.dias_pago_contado),
                    cine_inscripcion: Number(data.cine_inscripcion),
                    cine_colegiatura: Number(data.cine_colegiatura),
                    cine_colegiatura_tardia: Number(data.cine_colegiatura_tardia),
                    cine_total_colegiaturas: Number(data.cine_total_colegiaturas),
                    cine_total_contado: Number(data.cine_total_contado),
                    marketing_inscripcion: Number(data.marketing_inscripcion),
                    marketing_colegiatura: Number(data.marketing_colegiatura),
                    marketing_colegiatura_tardia: Number(data.marketing_colegiatura_tardia),
                    marketing_total_colegiaturas: Number(data.marketing_total_colegiaturas),
                    marketing_total_contado: Number(data.marketing_total_contado),
                    costo_extraordinario: Number(data.costo_extraordinario)
                };
                let request = {
                    method: 'PATCH',
                    body: JSON.stringify(body),
                    headers: authHeader()
                }

                let response = await fetch(url, request);
                let res = await response.json();
                if (response.ok) {
                    Swal.fire(
                        'Modificación exitosa!',
                        'Datos de aspirantes modificados correctamente' ,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudieron modificar los datos de aspirantes' ,
                        'error'
                    )
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Modificación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        });
    }
}

export default Aspirantes;
